"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Card_1 = __importStar(require("~/components/blog/supervisor_carousel/Card"));
var DISPLAY_CONTENT_COUNT_SP = 2;
var DISPLAY_CONTENT_COUNT_PC = 6;
var MIN_PAGE = 1;
// FIXME: カルーセルをページ送り部分 + 中身部分で共通化したい..
var List = function (_a) {
    var isSmartPhone = _a.isSmartPhone, supervisors = _a.supervisors;
    var _b = react_1.default.useState(1), page = _b[0], setPage = _b[1];
    var _c = react_1.default.useState(0), marginLeft = _c[0], setMarginLeft = _c[1];
    var displayContentCount = isSmartPhone ? DISPLAY_CONTENT_COUNT_SP : DISPLAY_CONTENT_COUNT_PC;
    var maxPage = Math.ceil(supervisors.length / displayContentCount);
    var paginate = function (page) {
        setMarginLeft((Card_1.CARD_WIDTH * displayContentCount) * (page - 1) * -1);
        setPage(page);
    };
    var handleClickLeftArrow = function () {
        if (page > MIN_PAGE) {
            paginate(page - 1);
        }
    };
    var handleClickRightArrow = function () {
        if (page < maxPage) {
            paginate(page + 1);
        }
    };
    return (react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-List_Container" },
        react_1.default.createElement("div", { onClick: handleClickLeftArrow, className: (0, classnames_1.default)("coBlogSupervisorCarousel-List_Arrow", "coBlogSupervisorCarousel-List_Arrow-left", { "coBlogSupervisorCarousel-List_Arrow-disabled": page === MIN_PAGE }) },
            react_1.default.createElement("i", { className: "fa fa-chevron-left" })),
        react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-List_CardList" },
            react_1.default.createElement("div", { className: "coBlogSupervisorCarousel-List_CardListInner", style: { marginLeft: marginLeft } }, supervisors.map(function (item, idx) { return (react_1.default.createElement(Card_1.default, { key: idx, supervisor: item })); }))),
        react_1.default.createElement("div", { onClick: handleClickRightArrow, className: (0, classnames_1.default)("coBlogSupervisorCarousel-List_Arrow", "coBlogSupervisorCarousel-List_Arrow-right", { "coBlogSupervisorCarousel-List_Arrow-disabled": page === maxPage }) },
            react_1.default.createElement("i", { className: "fa fa-chevron-right" }))));
};
exports.default = List;
